<div   class="mini-content" [formGroup]="form">
  <div class="input">
    <mat-form-field appearance="outline">
      <mat-label>Evidencia</mat-label>
      <input type="text" matInput formControlName="evidence" />
    </mat-form-field>
  </div>
  <div class="button">
    <button
      class="primary-btn rounded"
      [disabled]="!form.valid"
      mat-raised-button
      (click)="add()"
    >
      {{ isEditing ? "Editar" : "Agregar" }}
    </button>
    <button
      *ngIf="isEditing"
      class="cancel-btn rounded"
      mat-raised-button
      (click)="cancelEdit()"
    >
      Cancelar
    </button>
  </div>
</div>